import { ApolloClient, createHttpLink, ApolloLink, InMemoryCache } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { getToken, getLoginUrl } from '@/utils/auth';

const { VUE_APP_API_URL, VUE_APP_API_ALPHA_URL, VUE_APP_API_SPEEDBOAT_URL } = process.env;

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = getToken();

  operation.setContext({ headers: { authorization: token ? `Bearer ${token}` : '' } });
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      // Check for UNAUTHENTICATED error
      if ((extensions && extensions.code === 'UNAUTHENTICATED') || message.includes('UNAUTHENTICATED')) {
        window.location.href = getLoginUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
      }
    });
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
    // Check for 401 Unauthorized responses
    if (networkError.statusCode === 401) {
      window.location.href = getLoginUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
    }
  }
});

const httpLinkGateway = createHttpLink({
  // You should use an absolute URL here
  uri: VUE_APP_API_URL,
  headers: {
    organization: 'WEBTALES',
    application: 'UCPA COLLABORATORS'
  }
});

const httpLinkAlpha = createHttpLink({
  // You should use an absolute URL here
  uri: VUE_APP_API_ALPHA_URL
});

const httpLinkSpeedboat = createHttpLink({
  // You should use an absolute URL here
  uri: VUE_APP_API_SPEEDBOAT_URL,
  headers: {
    organization: 'WEBTALES',
    application: 'UCPA COLLABORATORS'
  }
});

const linkGateway = ApolloLink.from([
  errorLink,
  authMiddleware,
  httpLinkGateway
]);

const linkAlpha = ApolloLink.from([
  errorLink,
  authMiddleware,
  httpLinkAlpha
]);

const linkSpeedboat = ApolloLink.from([
  errorLink,
  authMiddleware,
  httpLinkSpeedboat
]);

const cache = new InMemoryCache({ addTypename: false });

const gatewayClient = new ApolloClient({
  name: 'collaborator-dashboard',
  link: linkGateway,
  cache: cache
});

const alphaClient = new ApolloClient({
  name: 'collaborator-dashboard',
  link: linkAlpha,
  cache: cache
});

const speedboatClient = new ApolloClient({
  name: 'collaborator-dashboard',
  link: linkSpeedboat,
  cache: cache
});

export { gatewayClient, alphaClient, speedboatClient };
